/**
 * Minimum accepted W/H dimension for Points/Picas, in points — matches the canvas's own resize
 * floor (`SHAPE_MIN_DIMENSION` in `selection-chrome-constants.ts`; 1 px = 1 pt). Picas' message
 * shows the real conversion (0p0.000833). Inches is enforced against its own independent floor —
 * see `MIN_VALUE_INCHES_IN` below — rather than this value converted, since 0.01 pt converted to
 * inches (≈0.000139 in) is smaller than the natural inches floor and would reject a legitimate
 * `0.0001 in` entry.
 */
export const MIN_VALUE_PT = 0.01

/**
 * Inches' own minimum, in inches — enforced directly (not derived from `MIN_VALUE_PT`), so
 * `0.0001 in` (≈0.0072 pt) is accepted even though it's below the Points/Picas floor above. See
 * `belowMinimumError` and `validateDimensionPoints`.
 */
export const MIN_VALUE_INCHES_IN = 0.0001

/** Pasteboard maximum dimension in points */
export const MAX_VALUE_PT = 6000

/** Max decimal places accepted; values with more are rounded to ROUND_PASTED_TO decimals */
export const MAX_DECIMAL_PLACES = 4

export const ROUND_PASTED_TO = 4

export const PT_PER_INCH = 72

export const PT_PER_PICA = 12

/** Precision for bound values in range-validation messages — higher than the 4 decimals used
 * for live input display so a tiny bound (e.g. `MIN_VALUE_PT` in Picas) never rounds to "0". */
export const BOUND_DISPLAY_DECIMALS = 6
